import { useAppContext } from "../../AppProvider";
import { responsiveParcels } from "./Layout/ResponsiveParcels";

export const ParcelHeader = () => {
  const { dictionary, display } = useAppContext();

  const styles = responsiveParcels();

  return (
    <>
      {(display.lg || display.xl || display.xxl) && (
        <>
          <div
            data-grid-template="parcelsHeader"
            className="d-grid gap-2 p-2"
            style={styles.header}
          >
            <div style={styles.cells.internalReference}>
              <label className="label-2">
                {dictionary.references.internal_reference}
              </label>
            </div>
            <div style={styles.cells.width}>
              <label className="label-2">
                {dictionary.dimensions.width} (cm)
              </label>
            </div>
            <div style={styles.cells.length}>
              <label className="label-2">
                {dictionary.dimensions.length} (cm)
              </label>
            </div>
            <div style={styles.cells.height}>
              <label className="label-2">
                {dictionary.dimensions.height} (cm)
              </label>
            </div>
            <div style={styles.cells.weight}>
              <label className="label-2">
                {dictionary.dimensions.weight} (Kg)
              </label>
            </div>
            <div style={styles.cells.volume}>
              <label className="label-2">
                {dictionary.dimensions.volume} (m<sup>3</sup>)
              </label>
            </div>
          </div>
        </>
      )}
    </>
  );
};
